import { Box, Typography } from "@mui/material";

type ApprovalStatusProps = {
    status: 'APPROVED' | 'REJECTED' | 'PENDING' | string;
};

export const ApprovalSubmitedBar = ({status}: ApprovalStatusProps) => {

    let bgColor;
    let borderColor;
    let textColor;
    let text;

    switch(status) {
        case 'APPROVED':
            bgColor = "success.extraLighter";
            borderColor = "#28a745"; // Örnek yeşil ton
            textColor = "success.main";
            text = 'ONAYLANDI';
            break;

        case 'REJECTED':
            bgColor = "error.extraLighter";
            borderColor = "#ff0000";
            textColor = "error.main";
            text = 'REDDEDİLDİ';
            break;

        case 'PENDING':
            bgColor = "primary.extraLighter"; 
            borderColor = "#007BFF"; 
            textColor = "primary.main";
            text = 'Onay Bekleniyor';
            break;

        default:
            bgColor = "warning.extraLighter";
            borderColor = "#ffb800";
            textColor = "warning.main";
            text = 'BİLİNMİYOR';
            break;
    }

    return (
        <Box sx={{textAlign: 'center', width: 200, borderRadius: 2, backgroundColor: bgColor, border: `1px solid ${borderColor}`}}>
            <Typography variant="overline" color={textColor}>{text}</Typography>
        </Box>
    );
}
